import React from 'react';
import { Form, Formik } from 'formik';
import { Button, Grid, SideSheet } from 'ui-toolkit';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { lenderContactFormValidation } from '../../validation/lenders/LenderContactFormValidation';
import { LenderContactForm } from './LenderContactForm';
import { FormStatusWrapper } from '../shared/FormStatusWrapper/FormStatusWrapper';
import {
  eContactEnvironment,
  eContactType,
  getContactDuplicationMessage,
} from '../../utilities/contact/duplicationErrorMessage';

interface IAddLenderContactProps {
  onSubmit: (value: any) => void;
  onCancel: () => void;
  addFetchError?: Error;
  addFetchStatus: IFetchStatus;
  onAddContact: (email: string) => void;
}

export const AddLenderContact: React.FC<IAddLenderContactProps> = ({
  onSubmit,
  onCancel,
  addFetchError,
  addFetchStatus,
  onAddContact,
}) => {
  const initialValues = {};

  return (
    <Formik
      initialValues={initialValues}
      validateOnMount={true}
      validationSchema={lenderContactFormValidation}
      onSubmit={(values) => {
        onSubmit(values);
      }}
      onReset={onCancel}
    >
      {({ isValid, dirty, handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <SideSheet
            title={'New Contact'}
            onClose={onCancel}
            footer={
              <Grid columnCount={2}>
                <Button intent={'secondary'} type={'reset'}>
                  Cancel
                </Button>
                <Button intent={'primary'} type={'submit'} disabled={!isValid || !dirty || addFetchStatus.fetching}>
                  Save and Add
                </Button>
              </Grid>
            }
          >
            <Grid>
              <>
                <FormStatusWrapper
                  fetching={addFetchStatus.fetching}
                  fetchedSuccess={addFetchStatus.success}
                  fetchError={addFetchError}
                  successMessage={`Contact Added!`}
                  duplicateMessage={getContactDuplicationMessage(eContactType.ThirdParty, eContactEnvironment.Lender)}
                />
                <LenderContactForm disableNotEditableFields={false} onAddContact={onAddContact} />
              </>
            </Grid>
          </SideSheet>
        </Form>
      )}
    </Formik>
  );
};
